import { render, staticRenderFns } from "./EmployeeCertificates.vue?vue&type=template&id=392160d4"
import script from "./EmployeeCertificates.vue?vue&type=script&lang=js"
export * from "./EmployeeCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports